import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a timezone string (i.e. America/Los_Angeles) for display.
 * Currently just replaces underscores with spaces.
 */
@Pipe({
  name: 'timezone',
})
export class TimezonePipe implements PipeTransform {
  transform(tz: string): string {
    if (!tz) {
      return '';
    }
    return tz.replace(/_/g, ' ');
  }
}
